import React from "react";
import Routes from "./Routes";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Routes />
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
